import * as authService from '@/data/api/auth'

export interface FindUserResp {
  id: number,
  username: string,
  directory: string,
  forename: string,
  surname: string,
  micadUser: boolean,
}

export async function findUser(q: string): Promise<FindUserResp[] | null> {
  try {
    const r = await authService.api.get("/api/user/find", {params: {q}})
    if (!r) {
      return null
    }
    return r.data as FindUserResp[]
  } catch (err) {
    console.log("findUser", err)
    return null
  }
}
